import { createElementObject, createLayerComponent, extendContext, updateMediaOverlay } from './core';
// import { VideoOverlay as LeafletVideoOverlay } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { VideoOverlay as LeafletVideoOverlayInstance, VideoOverlayOptions } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { LeafletContextInterface, MediaOverlayProps } from './core';
const LeafletVideoOverlay = L.VideoOverlay;

export interface VideoOverlayProps extends MediaOverlayProps, VideoOverlayOptions {
    children?: ReactNode
    play?: boolean
    url: string | string[] | HTMLVideoElement
}

export const VideoOverlay = createLayerComponent(function createVideoOverlay({ bounds , url , ...options }: VideoOverlayProps, ctx: LeafletContextInterface) {
    const overlay = new LeafletVideoOverlay(url, bounds, options);
    if (options.play === true) {
        overlay.getElement()?.play();
    }
    return createElementObject(overlay, extendContext(ctx, {
        overlayContainer: overlay
    }));
}, function updateVideoOverlay(overlay: LeafletVideoOverlayInstance, props: VideoOverlayProps, prevProps: VideoOverlayProps) {
    updateMediaOverlay(overlay, props, prevProps);
    if (typeof props.url === 'string' && props.url !== prevProps.url) {
        overlay.setUrl(props.url);
    }
    const video = overlay.getElement();
    if (video != null) {
        if (props.play === true && !prevProps.play) {
            video.play();
        } else if (!props.play && prevProps.play === true) {
            video.pause();
        }
    }
});
